import { Action } from 'redux';
// Import States.
import {
	AppState,
	NewBusinessApplicationPreliminaryState,
	getInitialNewBusinessApplicationPreliminaryState,
} from '@app/redux/states';
// Import Actions.
import {
	SaveNewBusinessApplicationPreliminaryPerilsAction,
	SaveNewBusinessApplicationPreliminaryPropertyAddressAction,
} from '@app/redux/actions';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };
	// Initialize the state.
	if (newState.newBusinessApplicationPreliminary === undefined) {
		newState.newBusinessApplicationPreliminary = getInitialNewBusinessApplicationPreliminaryState();
	}
	else {
		newState.newBusinessApplicationPreliminary = { ...newState.newBusinessApplicationPreliminary }
	}

	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryNewBusinessApplicationPreliminaryState = (state: AppState): NewBusinessApplicationPreliminaryState => {
	return state.newBusinessApplicationPreliminary;
}


// Clear New Business Application Preliminary Reducer.

let ClearNewBusinessApplicationPreliminaryReducer = (state: AppState, action: Action): AppState => {
	// Create copy of the of app state.
	let newState: AppState = initializeState(state);
	// Reset the state.
	newState.newBusinessApplicationPreliminary = getInitialNewBusinessApplicationPreliminaryState();

	return newState;
}


// Save New Business Application Preliminary Perils Reducer.

let SaveNewBusinessApplicationPreliminaryPerilsReducer = (state: AppState, action: Action): AppState => {
	let saveNewBusinessApplicationPreliminaryPerilsAction: SaveNewBusinessApplicationPreliminaryPerilsAction = action as SaveNewBusinessApplicationPreliminaryPerilsAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	// Query the state.
	let newBusinessApplicationPreliminaryState: NewBusinessApplicationPreliminaryState = queryNewBusinessApplicationPreliminaryState(newState);

	newBusinessApplicationPreliminaryState.perilsDeductibles = saveNewBusinessApplicationPreliminaryPerilsAction.perilsDeductibles;

	return newState;
}


// Save New Business Application Preliminary Property Address Reducer.

let SaveNewBusinessApplicationPreliminaryPropertyAddressReducer = (state: AppState, action: Action): AppState => {
	let saveNewBusinessApplicationPreliminaryPropertyAddressAction: SaveNewBusinessApplicationPreliminaryPropertyAddressAction = action as SaveNewBusinessApplicationPreliminaryPropertyAddressAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	// Query the state.
	let newBusinessApplicationPreliminaryState: NewBusinessApplicationPreliminaryState = queryNewBusinessApplicationPreliminaryState(newState);

	newBusinessApplicationPreliminaryState.propertyAddress = saveNewBusinessApplicationPreliminaryPropertyAddressAction.propertyAddress;

	return newState;
}


// Export reducers.
export {
	ClearNewBusinessApplicationPreliminaryReducer,
	SaveNewBusinessApplicationPreliminaryPerilsReducer,
	SaveNewBusinessApplicationPreliminaryPropertyAddressReducer,
};